import { Component, OnInit } from '@angular/core';
import { faEye, faFilePdf, faTrash } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ModalDetalhesPdvComponent } from 'src/app/shared/modals/modal-detalhes-pdv/modal-detalhes-pdv.component';
import Swal from 'sweetalert2';
import { BeneficioService } from '../../../services/previdencia/beneficio.service';
@Component({
  selector: 'app-minhas-solicitacoes',
  templateUrl: './minhas-solicitacoes.component.html',
  styleUrls: ['./minhas-solicitacoes.component.css']
})
export class MinhasSolicitacoesPdvComponent implements OnInit {
  faEye = faEye;
  faTrash = faTrash;
  faPdf = faFilePdf;
  loading: boolean = false;
  listaSolicitacoes!: any[];
  constructor(private beneficioService: BeneficioService, private modalService: NgbModal, private toast: ToastrService) {
  }
  buscarSolicitacoes() {
    this.loading = true;
    this.beneficioService.getSolicitations().subscribe({
      next: (res: any) => {
        this.listaSolicitacoes = res.items
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
      }
    })
  }
  visualizardetalhes(solicitacao: any) {
    const modalRef = this.modalService.open(ModalDetalhesPdvComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.solicitacao = solicitacao;
  }
  cancelarSolicitacao(solicitacao: any) {
    this.beneficioService.deleteCancelar(solicitacao.solicitationId).subscribe({
      next: (res: any) => {
        Swal.fire({
          title: "Cancelamento solicitado com sucesso",
          text: "",
          icon: "success",
          timer: 1500
        }).then(() => {
          this.buscarSolicitacoes();
        })
      },
      error: (err: any) => {
        Swal.fire({
          title: "Oops... Ocorreu um erro!",
          text: "",
          icon: "error",
          timer: 1500
        }).then(() => {
          this.buscarSolicitacoes();
        })
      }
    })
  }
  downloadPdf(solicitacao: any) {
    this.beneficioService.getPdf(solicitacao.solicitationId).subscribe({
      next: (data: Blob) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Solicitação programa demissão voluntário.pdf";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
        this.toast.success('Pdf extraido com sucesso!');
      },
      error: (err: any) => {
        this.toast.error('');
      }
    })
  }
  getRefundStatusColor(status: number) {
    let color = '#707070';
    if (status == 1) {
      color = '#E4E408'
    } else if (status == 2) {
      color = '#3CCB1B';
    } else if (status == 3) {
      color = '#d10000'
    } else if (status == 4) {
      color = '#EF3F3F'
    }
    return color;
  }
  ngOnInit(): void {
    this.buscarSolicitacoes();
  }
}
